<template>
  <v-app id="inspire">

    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container fluid fill-height align-start>
        <v-row  >
          <v-col md="12" lg="12" cols="12">
            <h1 class="text-h3 text-center" style="color: #393E46;">Entradas para {{evento.nombre}}</h1>
            <br />

            <v-alert
                :value="alertnuevo"
                color="primary"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Su Entrada se agrego con éxito.
            </v-alert>
            <v-alert
                :value="alerteditar"
                color="green"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Su Entrada se edito con éxito.
            </v-alert>
            <v-data-table
                :headers="headers"
                :items="EventoTickets"
                sort-by="eventoEntrada"
                sort-desc
                class="elevation-1"
                :search="search"
                :loading="loading"
                no-data-text="No hay datos disponibles para mostrar."
                no-results-text="No hay resultados para la búsqueda."
                loading-text="Cargando... Por favor espere."
                style="background-color: #393E46;"
            >
              <template v-slot:top>
                <v-toolbar flat >
                  <v-progress-circular
                      indeterminate
                      v-if="progr === true"
                      color="primary"
                  ></v-progress-circular>
                  <v-divider
                      class="mx-4"
                      inset
                      vertical
                  ></v-divider>
                  <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialogdelete" persistent max-width="350">
                    <v-card color="#393E46">
                      <v-card-title class="headline">Desea eliminar esta Ticket?</v-card-title>
                      <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="close">No</v-btn>
                        <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-dialog v-model="dialog" max-width="600px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">Nueva Entrada</v-btn>
                    </template>
                    <v-card  color="#393E46">
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <v-text-field v-model="editedItem.eventoEntrada" label="Nombre"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                              <v-autocomplete
                                  :items="EventoZonas"
                                  v-model="editedItem.eventoZona"
                                  return-object
                                  label="Zona del Evento"
                                  item-text="zona"
                                  item-value="id"
                                  hint="Elegir Zona del Evento"
                                  persistent-hint
                              >
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" v-if="mostrartipoentrada">
                              <v-autocomplete
                                  :items="tipoentradas"
                                  v-model="editedItem.tipoEntrada"
                                  return-object
                                  label="Tipo de Entrada"
                                  item-text="tipoEntrada"
                                  item-value="id"
                                  hint="Elegir Tipo de Entrada"
                                  persistent-hint
                              >
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" v-if="tipoEventoId === 1 || tipoEventoId ===3">
                              <v-autocomplete
                                  :items="Monedas"
                                  v-model="editedItem.moneda"
                                  return-object
                                  label="Moneda"
                                  item-text="moneda"
                                  item-value="id"
                                  hint="Elegir Moneda"
                                  persistent-hint
                              >
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="6" sm="6" md="6"  v-if="tipoEventoId === 1 || tipoEventoId ===3">
                              <v-text-field v-model="editedItem.precio" label="Precio"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="6">
                              <v-text-field v-model="editedItem.cantidad" label="Máxima Cantidad de Entradas"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="6">
                              <v-menu
                                  ref="menu1"
                                  v-model="menu1"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-model="editedItem.fechaInicio" label="Fecha de Inicio"
                                                hint="YYYY-MM-DD" persistent-hint
                                                @blur="blurfecha"
                                                v-on="on"
                                                prepend-icon="fas fa-calendar" ></v-text-field></template>
                                <v-date-picker
                                    v-model="date"
                                    no-title
                                    :min="hoy"
                                    @input="menu1 = false"
                                    @change="cambiafecha1"
                                ></v-date-picker>
                              </v-menu>

                            </v-col>
                            <v-col cols="6" sm="6" md="6">
                              <v-menu
                                  ref="menu2"
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-model="editedItem.fechaFin" label="Fecha Vencimiento"
                                                hint="YYYY-MM-DD" persistent-hint
                                                @blur="blurfecha2"
                                                v-on="on"
                                                prepend-icon="fas fa-calendar" ></v-text-field></template>
                                <v-date-picker
                                    v-model="date2"
                                    no-title
                                    :min="hoy"
                                    @input="menu2 = false"
                                    @change="cambiafecha2"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                              <v-textarea name="descripcion" v-model="editedItem.descripcion" label="Descripcion"></v-textarea>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-icon
                    small
                    color="blue"
                    class="mr-2"
                    @click="editItem(item)"
                >
                  fas fa-edit
                </v-icon>
                <v-icon
                    small
                    color="error"
                    class="mr-2"
                    @click="deleteItem(item)"
                >
                  fas fa-minus-circle
                </v-icon>
              </template>
              <template v-slot:[`item.dactiva`]="{ item }">
                <v-switch v-model="item.activo" @click="activaEventoTicket(item)" ></v-switch>
              </template>
              <template v-slot:[`item.fechai`]="{ item }">
                {{formatDatee(item.fechaInicio)}}
              </template>
              <template v-slot:[`item.fechaf`]="{ item }">
                {{formatDatee(item.fechaFin)}}
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="dameEventoTickets">Cargar de Nuevo</v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <leftmenueventos :abreviado="abreviado" />

      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenueventos from '../../general/leftmenueventos';
import axios from 'axios';
import moment from "moment";
import firebase from 'firebase/compat/app';

export default {
  components: {
    leftmenueventos,
  },
  data: () => ({
    drawer: null,
    idnegocio: 0,
    dbreads: [
      {
        text: 'Eventos',
        disabled: true,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'Entradas',
        disabled: true,
        href: 'breadcrumbs_link_2',
      },
    ],
    progr: true,
    alertborrador: false,
    alertnuevo: false,
    alerteditar: false,
    loading:true,
    abreviado:'NN',

    dialog: false,
    dialogdelete: false,
    hoy: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu1: false,
    menu2: false,
    eventoId:0,
    eventoNombre:'',
    tipoEventoId:0,
    eventoTag:'',
    EventoTickets: [],
    EventoZonas:[],
    Monedas:[],
    search: '',
    mostrartipoentrada:false,
    token:'',
    tipoentradas:[{
      id:1,pago:false,tipoEntrada:"Cortesia"
    },
      {id:2, pago:true,tipoEntrada: "Pago"}],
    editedIndex: -1,
    monedaCortesia:{
      id:0,
      moneda:'Cortesia',
      shortmoneda: 'C',
      pais:{
        id:0,
        activo:false,
        codigo:'NN',
        importancia: 0,
        pais:'NO PAIS'
      },
      codigoMoneda:'COR'
    },
    editedItem: {
      id: null,
      eventoEntrada: '',
      activo: false,
      cantidad: 0,
      precio: 0,
      descripcion: '',
      fechaInicio: '',
      fechaFin: '',
      codigoUnico:'',
      eventoZona: {},
      tipoEntrada:{},
      moneda:{}
    },
    defaultItem: {
      id: null,
      eventoEntrada: '',
      activo: false,
      cantidad: 0,
      precio: 0,
      descripcion: '',
      fechaInicio: '',
      fechaFin: '',
      codigoUnico:'',
      eventoZona: {},
      tipoEntrada:{},
      moneda:{}
    },
    headers: [
      { text: 'Acciones', value: 'action', sortable: false },
      { text: 'Entrada', align: 'left',  value: 'eventoEntrada'},
      { text: 'Zona', align: 'left',  value: 'eventoZona.zona'},
      { text: 'Fecha Inicio', align: 'left',  value: 'fechai'},
      { text: 'Fecha Vencimiento', align: 'left',  value: 'fechaf'},
      { text: 'Precio', align: 'left',  value: 'precio'},
      { text: 'Maximo', align: 'left',  value: 'cantidad'},
      { text: 'Activo', value: 'dactiva' },
    ]
  }),
  mounted (){
    if(this.cliente == null){
      this.$router.push({ name: 'creacliente' });
    }else{
      if (this.cliente.id > 0) {
        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

        this.editedItem.fechaInicio = this.formatDate(this.date);

    this.editedItem.fechaFin = this.formatDate(this.date2);
    this.tipoEventoId = this.evento.tipoEvento.id

    this.dameEventoZonas();
        this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
    if(this.tipoEventoId === 2){
      this.editedItem.tipoEntrada = this.tipoentradas.find(x=>x.id === 1)
      this.editedItem.moneda = this.monedaCortesia
    }else {
      this.dameMonedas();
      if(this.tipoEventoId === 3){
        this.mostrartipoentrada = true;
      }else{
        this.editedItem.tipoEntrada = this.tipoentradas.find(x=>x.id === 2)

      }
    }
      }else{
        this.$router.push({ name: 'creacliente' });
      }
  }
    },
  watch: {
    dialog (val) {
      val || this.close()
    },
    date () {
      this.editedItem.fechaInicio = this.formatDate(this.date)
    },
    date2 () {
      this.editedItem.fechaFin = this.formatDate(this.date2)
    },
  },
  methods : {
    cambiafecha1(){
      this.editedItem.fechaInicio = this.date
    },
    cambiafecha2(){
      this.editedItem.fechaFin = this.date2
    },
    blurfecha2(){
      this.date2 = this.editedItem.fechaFin
    },
    blurfecha(){
      this.date = this.editedItem.fechaInicio
    },
    formatDatee(value) {
      return moment(value).month(moment(value).month()-1).locale('es-pe').format("DD MMMM YYYY")
    },
    formatDatree(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    formatDarete (date) {
      var fec = moment(date).locale('es-pe');
      console.log(fec);
      return fec.tz(this.cliente.timeZone.timeZone).format("DD-MM-YYYY");
    },
    formatDate (date) {
      return moment(date).locale('es-pe').format("YYYY-MM-DD");
    },
    borralo (){
      var bodyFormData2 = new FormData();
      bodyFormData2.append("data",JSON.stringify(this.editedItem));
      axios
          .delete('eventoentradas',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.dialogdelete = false;
            this.alertborrador = true;
            this.EventoTickets = response.data
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
    },
    dameEventoZonas(){
      this.progr = true;
      let urlEventoZona = 'zonas/evento/' + this.evento.id ;
      axios
          .get(urlEventoZona,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.EventoZonas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            if(this.EventoZonas.length > 0){
            this.dameEventoTickets();}else{
              this.$router.push({name:'ZonaEvento', params: {zonas:'true'}})
            }
          })
          .catch((error)  => {
            console.log(error);
            this.progr = false;
          });
    },
    dameMonedas(){
      this.progr = true;
      let urlEventoZona = 'monedas/pais/' + this.cliente.pais.id ;
      axios
          .get(urlEventoZona,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.Monedas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    dameEventoTickets(){
      this.progr = true;
      let urlEventoTicket = 'eventoentradas/evento/' + this.evento.id ;
      axios
          .get(urlEventoTicket,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.EventoTickets = response.data;
            this.progr = false;
            this.loading = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
          })
          .catch((error)  => {
            console.log(error);
            this.loading = false;
            this.progr = false;
          });
    },
    editItem (item) {
      this.editedIndex = this.EventoTickets.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true

    },
    deleteItem (item) {
      this.editedIndex = this.EventoTickets.indexOf(item);
      this.dialogdelete = true;
    },
    activaEventoTicket (item) {
      this.editedItem = Object.assign({}, item)
      var bodyFormData2 = new FormData();
      bodyFormData2.append("data",JSON.stringify(this.editedItem));
      axios
          .post('eventoentradas/grabar',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          }).then(response => {
        console.log(response);
      })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      var bodyFormData2 = new FormData();
      if (this.editedIndex > -1) {
        Object.assign(this.EventoTickets[this.editedIndex], this.editedItem);
        this.editedItem.fechaInicio = this.formatDarete(new Date(this.editedItem.fechaInicio+"T00:00:00"))
        this.editedItem.fechaFin = this.formatDarete(this.editedItem.fechaFin+"T00:00:00")
        if(this.editedItem.precio>0){
          this.editedItem.tipoEntrada = this.tipoentradas.find(x=>x.id ===2)
        }else{
          this.editedItem.tipoEntrada = this.tipoentradas.find(x=>x.id ===3)
        }
        this.editedItem.eventoZona.evento.fechaInicio = this.formatDarete(this.editedItem.eventoZona.evento.fechaInicio+"T00:00:00")
        this.editedItem.eventoZona.evento.fechaFinal = this.formatDarete(this.editedItem.eventoZona.evento.fechaFinal+"T00:00:00")
        bodyFormData2.append("data",JSON.stringify(this.editedItem));
        axios
            .post('eventoentradas/grabar',bodyFormData2,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
              }
            }).then(response => {
          console.log(response);
          this.alerteditar = true;
          this.dameEventoTickets();
        })
            .catch(error => {
              this.error = "Hubo un error";
              console.log(error);
            });
      } else {
        this.editedItem.activo = true
        if(this.editedItem.precio>0){
          this.editedItem.tipoEntrada = this.tipoentradas.find(x=>x.id ===2)
        }else{
          this.editedItem.tipoEntrada = this.tipoentradas.find(x=>x.id===1)
        }
        this.editedItem.fechaInicio = this.formatDarete(new Date(this.editedItem.fechaInicio+"T00:00:00"))
        this.editedItem.fechaFin = this.formatDarete(this.editedItem.fechaFin+"T00:00:00")
        this.editedItem.eventoZona.evento.fechaInicio = this.formatDarete(this.editedItem.eventoZona.evento.fechaInicio+"T00:00:00")
        this.editedItem.eventoZona.evento.fechaFinal = this.formatDarete(this.editedItem.eventoZona.evento.fechaFinal+"T00:00:00")

        bodyFormData2.append("data",JSON.stringify(this.editedItem));
        axios
            .post('eventoentradas/grabar',bodyFormData2,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
              }
            }).then(response => {
          this.dameEventoTickets();
          this.alertnuevo = true;
          console.log(response);
        })
            .catch(error => {
              this.error = "Hubo un error";
              console.log(error);
            });
      }
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Entrada' : 'Editar Entrada'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    computedDate2Formatted () {
      return this.formatDate(this.date2)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      cliente: "cliente",
      evento: "evento"
    })
  }
};
</script>
